import { createContext, useEffect, useReducer } from "react";
import languageState from "./State";
import languageReducers from "./Reducers";
import { languagesActions } from "./actions";
import { LanguageEnum, LanguageType } from "./language.props";

export const LanguageContext = createContext(languageState);

const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(languageReducers, languageState);

  useEffect(() => {
    const { changeLanguage } = languagesActions(dispatch);
    changeLanguage(
      (localStorage.getItem(LanguageEnum.SET) as LanguageType) ?? "es"
    );
  }, []);

  return (
    <LanguageContext.Provider value={{ ...state, dispatch }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
